import { join, camelCase, get } from 'lodash';
import Codes from '../codes';

const getCodes = (client, groups) => Promise.resolve()
  .then(() => {
    const codeNames = groups.map((groupName) => camelCase(groupName));
    return codeNames.reduce((acc, codeName) => {
      acc[codeName] = get(Codes, codeName, {}).values;
      return acc;
    }, {});
  });

const getRegionGroups = (client, params) => client.request({
  url: '/v1/application/planRegionGroups',
  method: 'get',
  params,
});

const getBillings = (client, params) => client.request({
  url: '/v1/application/planBillings',
  method: 'get',
  params,
});

const getApplicationTags = (client, params) => client.request({
  url: '/v1/application/planApplicationTags',
  method: 'get',
  params,
  local: true,
});

const getCarGroups = (client, params) => client.request({
  url: '/v1/application/planCarGroups',
  method: 'get',
  params,
  local: true,
});

const getHolidays = (client, params) => client.request({
  url: '/v1/application/planHolidays',
  method: 'get',
  params,
  local: true,
});

export default {
  getCodes,
  getRegionGroups,
  getBillings,
  getApplicationTags,
  getCarGroups,
  getHolidays,
};
